<template>
  <div class="virtual-power-plant-page">
    <section class="common-section ecosystem-section">
      <section-title :titleInfo="ecosystemTitle"></section-title>
      <div class="ecosystem-card">
        <img class="ecosystem-background" src="../images/xndc/resource-ecosystem.jpg" alt="虚拟电厂资源聚合生态" />
        <div class="resource-network">
          <svg class="resource-lines" viewBox="0 0 900 560" preserveAspectRatio="none" aria-hidden="true">
            <path v-for="(line, index) in resourceLines" :key="index" :d="line" />
          </svg>
          <article
            v-for="resource in resources"
            :key="resource.title"
            class="resource-node"
            :class="resource.position"
          >
            <img :src="resource.image" :alt="resource.title" />
            <div><strong>{{ resource.title }}</strong><small>{{ resource.text }}</small></div>
          </article>
          <div class="vpp-hub">
            <span class="hub-ring"></span>
            <strong>VPP</strong>
            <small>虚拟电厂调度中心</small>
          </div>
        </div>
        <aside class="ability-panel">
          <article v-for="item in abilities" :key="item.title">
            <span><operation-icon :name="item.icon"></operation-icon></span>
            <div><h3>{{ item.title }}</h3><p>{{ item.text }}</p></div>
          </article>
        </aside>
      </div>
    </section>

    <section class="common-section dispatch-section">
      <section-title :titleInfo="dispatchTitle"></section-title>
      <div class="dispatch-flow">
        <article v-for="(item, index) in dispatchSteps" :key="item.title">
          <span class="step-index">0{{ index + 1 }}</span>
          <span class="step-icon"><operation-icon :name="item.icon"></operation-icon></span>
          <h3>{{ item.title }}</h3>
          <p>{{ item.text }}</p>
        </article>
      </div>
    </section>

    <section class="common-section scene-section">
      <section-title :titleInfo="sceneTitle"></section-title>
      <div class="scene-grid">
        <article v-for="scene in scenes" :key="scene.title" class="scene-card">
          <img :src="scene.image" :alt="scene.title" />
          <div><h3>{{ scene.title }}</h3><p>{{ scene.text }}</p></div>
        </article>
      </div>
      <div class="value-grid">
        <article v-for="item in values" :key="item.title">
          <span><operation-icon :name="item.icon"></operation-icon></span>
          <div><h3>{{ item.title }}</h3><p>{{ item.text }}</p></div>
        </article>
      </div>
    </section>

    <section class="contact-banner">
      <div>
        <h2>携手智融科技，共建智慧能源新生态</h2>
        <p>聚合每一份资源，创造每一度价值</p>
      </div>
      <a href="tel:02583585700"><span>立即咨询</span><strong>025-83585700</strong></a>
    </section>
  </div>
</template>

<script>
import SectionTitle from "../../components/section-title.vue";
import OperationIcon from "./operation-icon.vue";

export default {
  name: "NyjhXndc",
  components: { SectionTitle, OperationIcon },
  data() {
    return {
      ecosystemTitle: {
        bigtext1: "资源聚合生态",
        smallText: "多源接入，协同互联，构建虚拟电厂生态网络",
      },
      dispatchTitle: {
        bigtext1: "协同调度闭环",
        smallText: "感知全局、智能决策，形成持续优化闭环",
      },
      sceneTitle: {
        bigtext1: "场景与价值",
        smallText: "多元场景应用，创造更多价值",
      },
      resources: [
        { title: "光伏发电", text: "清洁发电资源", image: require("../images/xndc/nodes/node-solar-transparent.webp"), position: "node-solar" },
        { title: "储能资源", text: "灵活充放调节", image: require("../images/xndc/nodes/node-storage-transparent.webp"), position: "node-storage" },
        { title: "充电桩", text: "有序充电负荷", image: require("../images/xndc/nodes/node-charging-transparent.webp"), position: "node-charging" },
        { title: "工商业负荷", text: "可调节用能", image: require("../images/xndc/nodes/node-industry-transparent.webp"), position: "node-industry" },
        { title: "可控负荷", text: "快速响应资源", image: require("../images/xndc/nodes/node-load-transparent.webp"), position: "node-load caption-above" },
        { title: "空调负荷", text: "柔性调节资源", image: require("../images/xndc/nodes/node-hvac-transparent.webp"), position: "node-hvac" },
        { title: "其他灵活资源", text: "多类型资源接入", image: require("../images/xndc/nodes/node-flexible-transparent.webp"), position: "node-flexible caption-above" },
      ],
      resourceLines: [
        "M450 280 C395 225 355 175 315 130",
        "M450 280 C438 205 438 160 450 112",
        "M450 280 C505 225 545 175 585 130",
        "M450 280 C370 280 320 280 255 280",
        "M450 280 C530 280 580 280 645 280",
        "M450 280 C395 345 355 390 315 434",
        "M450 280 C505 345 545 390 585 434",
      ],
      abilities: [
        { title: "多源接入", text: "汇聚多种分布式资源", icon: "multi-scene" },
        { title: "灵活调度", text: "智能协同，高效响应", icon: "schedule" },
        { title: "市场参与", text: "参与电力市场交易", icon: "power-trade" },
        { title: "稳定运行", text: "保障电网可靠平稳", icon: "shield" },
        { title: "绿色低碳", text: "促进清洁能源消纳", icon: "green" },
      ],
      dispatchSteps: [
        { title: "感知", text: "全面感知资源状态", icon: "data" },
        { title: "分析", text: "多维数据智能分析", icon: "aggregate" },
        { title: "决策", text: "科学决策最优策略", icon: "efficiency" },
        { title: "执行", text: "高效下发调度指令", icon: "shield" },
        { title: "反馈", text: "运行反馈持续跟踪", icon: "schedule" },
        { title: "优化", text: "持续优化提升效能", icon: "power-trade" },
      ],
      scenes: [
        { title: "园区场景", text: "智慧园区能源管理", image: require("../images/xndc/scene-campus.jpg") },
        { title: "工商业场景", text: "降本增效，优化用能", image: require("../images/xndc/scene-industry.jpg") },
        { title: "充电站场景", text: "错峰充电，灵活响应", image: require("../images/xndc/scene-charging.jpg") },
        { title: "微网场景", text: "能源自治，稳定供能", image: require("../images/xndc/scene-microgrid.jpg") },
        { title: "储能场景", text: "削峰填谷，提升收益", image: require("../images/xndc/scene-storage.jpg") },
        { title: "电力交易", text: "参与市场，创造价值", image: require("../images/xndc/scene-trading.jpg") },
      ],
      values: [
        { title: "资源接入", text: "广泛接入各类资源", icon: "multi-scene" },
        { title: "协同调度", text: "提升系统灵活性", icon: "aggregate" },
        { title: "市场参与", text: "把握市场机会", icon: "power-trade" },
        { title: "运营增值", text: "创造持续收益", icon: "efficiency" },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.virtual-power-plant-page { width: 100%; color: #17233a; background: #fff; }
.common-section { box-sizing: border-box; padding: 100px clamp(32px, 8.33vw, 160px); }
.ecosystem-section { background: linear-gradient(180deg, #f7faff, #fff); }
.ecosystem-card { height: 710px; position: relative; overflow: hidden; border: 1px solid #e2eaf5; border-radius: 12px; background: #f8fbff; box-shadow: 0 18px 48px rgba(22,74,150,.1); }
.ecosystem-background { width: 100%; height: 100%; display: block; object-fit: cover; }
.ecosystem-card::after { content: ""; position: absolute; inset: 0; pointer-events: none; background: linear-gradient(90deg, rgba(250,252,255,.08), rgba(250,252,255,0) 65%, rgba(250,252,255,.93) 83%); }
.resource-network { width: calc(100% - 366px); height: 610px; position: absolute; z-index: 2; top: 50%; left: 172px; transform: translateY(-50%); }
.resource-lines { width: 100%; height: 100%; position: absolute; inset: 0; overflow: visible; }
.resource-lines path { fill: none; stroke: #2f80ed; stroke-width: 2.2; stroke-dasharray: 8 6; opacity: .65; animation: flow 12s linear infinite; }
.resource-node { width: 236px; min-height: 138px; box-sizing: border-box; position: absolute; display: flex; align-items: center; gap: 1px; }
.resource-node > img { width: 154px; height: 132px; flex: none; display: block; object-fit: contain; filter: drop-shadow(0 11px 14px rgba(22,74,150,.18)); }
.resource-node > div { min-width: 0; position: relative; z-index: 1; margin-left: -6px; text-shadow: 0 1px 8px rgba(255,255,255,.98), 0 0 14px rgba(255,255,255,.98); }
.resource-node strong, .resource-node small { display: block; }
.resource-node strong { margin-bottom: 8px; color: #15366d; font-size: 17px; font-weight: 600; white-space: nowrap; }
.resource-node small { color: #5f718c; font-size: 12px; line-height: 1.5; white-space: nowrap; }
.node-solar,.node-industry,.node-hvac,.caption-above { width: 190px; min-height: 176px; justify-content: center; gap: 0; text-align: center; }
.node-solar { top: 6px; left: 21%; flex-direction: column; }
.node-industry,.node-hvac { flex-direction: column-reverse; }
.node-solar > div,.node-industry > div,.node-hvac > div,.caption-above > div { margin-left: 0; }
.caption-above { flex-direction: column; }
.caption-above > img { order: 3; }
.caption-above strong { margin-bottom: 4px; }
.node-storage { top: 12px; left: calc(50% - 118px); }
.node-charging { top: 18px; right: 19%; }
.node-industry { top: calc(50% - 88px); left: 15%; }
.node-load { top: calc(50% - 88px); right: 15%; }
.node-hvac { bottom: 6px; left: 21%; }
.node-flexible { right: 21%; bottom: 6px; }
.vpp-hub { width: 190px; height: 190px; position: absolute; top: 50%; left: 50%; display: flex; align-items: center; justify-content: center; flex-direction: column; color: #fff; border: 7px solid rgba(255,255,255,.92); border-radius: 50%; background: linear-gradient(145deg,#62c2ff,#1166e7 64%,#0846b6); box-shadow: 0 18px 45px rgba(17,99,225,.38), inset 0 0 28px rgba(255,255,255,.35); transform: translate(-50%,-50%); }
.hub-ring { position: absolute; inset: -25px; border: 1px solid rgba(42,122,242,.36); border-radius: 50%; box-shadow: 0 0 0 13px rgba(40,121,242,.08),0 0 0 27px rgba(40,121,242,.04); }
.vpp-hub strong { font-size: 46px; font-weight: 600; letter-spacing: 2px; }
.vpp-hub small { margin-top: 8px; color: rgba(255,255,255,.82); font-size: 12px; }
.ability-panel { width: 278px; box-sizing: border-box; padding: 26px 22px; position: absolute; z-index: 3; top: 50%; right: 24px; display: grid; gap: 13px; border: 1px solid #dbe7f6; border-radius: 11px; background: rgba(255,255,255,.96); box-shadow: 0 14px 34px rgba(22,74,150,.1); transform: translateY(-50%); }
.ability-panel article { min-height: 78px; display: flex; align-items: center; gap: 16px; }
.ability-panel article > span { width: 42px; height: 42px; flex: none; color: #1f63ea; }
h3,p { margin: 0; }
.ability-panel h3 { margin-bottom: 7px; font-size: 18px; font-weight: 500; }
.ability-panel p { color: #7d8797; font-size: 12px; }
.dispatch-section { background: #fff; }
.dispatch-flow { display: grid; grid-template-columns: repeat(6,1fr); }
.dispatch-flow article { min-width: 0; position: relative; text-align: center; }
.dispatch-flow article:not(:last-child)::after { content: ""; width: calc(100% - 100px); height: 2px; position: absolute; top: 47px; left: calc(50% + 50px); background: linear-gradient(90deg,#6da7ff,#d1e2fb); }
.dispatch-flow article:not(:last-child)::before { content: ""; position: absolute; z-index: 1; top: 43px; right: 15px; border-width: 5px 0 5px 8px; border-style: solid; border-color: transparent transparent transparent #78adfb; }
.step-index { position: absolute; top: -10px; left: calc(50% - 46px); color: #c5d8f5; font-size: 11px; }
.step-icon { width: 82px; height: 82px; margin: 0 auto 20px; padding: 18px; display: block; box-sizing: border-box; color: #fff; border: 7px solid #edf4ff; border-radius: 50%; background: linear-gradient(145deg,#4c9dff,#145bd7); box-shadow: 0 0 0 1px #c5ddff; }
.dispatch-flow h3 { margin-bottom: 9px; font-size: 20px; font-weight: 500; }
.dispatch-flow p { color: #7d8797; font-size: 13px; }
.scene-section { background: #f7f9fd; }
.scene-grid { display: grid; grid-template-columns: repeat(3,1fr); gap: 24px; }
.scene-card { overflow: hidden; border: 1px solid #e3eaf4; border-radius: 9px; background: #fff; box-shadow: 0 12px 30px rgba(22,66,133,.08); }
.scene-card img { width: 100%; height: 230px; display: block; object-fit: cover; transition: transform .4s; }
.scene-card:hover img { transform: scale(1.03); }
.scene-card > div { padding: 20px 22px; }
.scene-card h3 { margin-bottom: 8px; font-size: 20px; font-weight: 500; }
.scene-card p { color: #7d8797; font-size: 13px; }
.value-grid { margin-top: 32px; padding: 26px 28px; display: grid; grid-template-columns: repeat(4,1fr); border: 1px solid #e1e9f4; border-radius: 9px; background: #fff; }
.value-grid article { min-width: 0; padding: 0 26px; display: flex; align-items: center; gap: 16px; border-right: 1px solid #dfe6f0; }
.value-grid article:last-child { border-right: 0; }
.value-grid article > span { width: 44px; height: 44px; flex: none; color: #1f63ea; }
.value-grid h3 { margin-bottom: 6px; color: #1f63ea; font-size: 18px; font-weight: 500; }
.value-grid p { color: #7d8797; font-size: 12px; }
.contact-banner { min-height: 260px; box-sizing: border-box; padding: 54px clamp(32px,8.33vw,160px); display: flex; align-items: center; justify-content: space-between; gap: 40px; color: #fff; background: linear-gradient(90deg,rgba(5,59,155,.96),rgba(18,103,226,.78)),url("../images/xndc/xndc-banner.jpg") center 62%/cover no-repeat; }
.contact-banner h2 { margin: 0 0 15px; font-size: 34px; font-weight: 500; }
.contact-banner p { color: rgba(255,255,255,.8); font-size: 18px; }
.contact-banner a { min-width: 235px; padding: 16px 28px; display: flex; flex-direction: column; align-items: center; color: #1f63ea; border-radius: 5px; background: #fff; text-decoration: none; box-shadow: 0 12px 26px rgba(0,38,105,.18); }
.contact-banner a span { margin-bottom: 6px; font-size: 15px; }
.contact-banner a strong { font-size: 22px; font-weight: 500; }
@keyframes flow { to { stroke-dashoffset: -140; } }
@media (max-width:1450px) {
  .ecosystem-card { height: auto; padding: 28px; }
  .ecosystem-background { position: absolute; inset: 0; }
  .resource-network { width: 100%; max-width: 900px; height: 590px; position: relative; top: auto; left: auto; margin: 0 auto; transform: none; }
  .ability-panel { width: auto; position: relative; top: auto; right: auto; grid-template-columns: repeat(5,1fr); transform: none; }
  .ability-panel article { min-width: 0; }
}
@media (max-width:1100px) {
  .ability-panel { grid-template-columns: repeat(2,1fr); }
  .dispatch-flow { grid-template-columns: repeat(3,1fr); gap: 42px 0; }
  .dispatch-flow article:nth-child(3)::after,.dispatch-flow article:nth-child(3)::before { display:none; }
  .scene-grid { grid-template-columns: repeat(2,1fr); }
  .value-grid { grid-template-columns: repeat(2,1fr); gap: 28px 0; }
  .value-grid article:nth-child(2) { border-right:0; }
}
@media (max-width:760px) {
  .common-section { padding: 70px 22px; }
  .resource-network { height: auto; display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
  .resource-lines { display:none; }
  .resource-node { width:auto; min-height:118px; padding:8px; position:static; gap:4px; border:1px solid rgba(191,211,240,.84); border-radius:10px; background:rgba(255,255,255,.92); box-shadow:0 8px 20px rgba(24,91,184,.08); }
  .resource-node > img { width:96px; height:94px; }
  .resource-node > div { margin-left:-2px; text-shadow:none; }
  .node-solar,.node-industry,.node-hvac,.caption-above { width:auto; min-height:118px; flex-direction:row; justify-content:flex-start; text-align:left; }
  .caption-above > img { order:0; }
  .vpp-hub { width:auto; height:auto; min-height:130px; grid-column:1/-1; grid-row:1; position:relative; top:auto; left:auto; border-radius:12px; transform:none; }
  .hub-ring { display:none; }
  .ability-panel,.dispatch-flow,.scene-grid,.value-grid { grid-template-columns:1fr; }
  .dispatch-flow article::after,.dispatch-flow article::before { display:none; }
  .scene-card img { height:210px; }
  .value-grid article { border-right:0; }
  .contact-banner { align-items:flex-start; flex-direction:column; }
  .contact-banner h2 { font-size:28px; }
}
</style>
